import { Button } from '@livechat/design-system-react-components'

import { isAuthorized, isAppInstalled } from '@/store/selectors'
import useParamSelector from '@/hooks/useParamSelector'
import { useTypedSelector } from '@/store/hooks'

interface Props {
  id: string
  onClick: () => void
  onClose: () => void
}

const ReviewFormFooter = ({ id, onClick, onClose }: Props) => {
  const isUserAuthorized = useTypedSelector(isAuthorized)
  const isInstalled = useParamSelector(isAppInstalled, id)
  const canVote = isUserAuthorized && isInstalled

  return (
    <>
      <Button onClick={onClose}>Cancel</Button>

      <Button
        kind="primary"
        onClick={onClick}
        disabled={!canVote}
        type="submit"
        form="reviewForm"
      >
        Submit review
      </Button>
    </>
  )
}

export default ReviewFormFooter
